var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"base-alert",attrs:{"show":_vm.dismissCountDown,"fade":"","variant":_vm.variant},on:{"dismiss-count-down":_vm.countDownChanged}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }